import { useUserSettingsStore } from 'Js/store/useUserSettingsStore.js';
const closeWindowUrl = '/security/CloseWindow';
let isReauthenticating = false;
/**
 * Reauthenticate the current cookie session when the BFF no longer recognizes it.
 */
export async function reauthenticate() {
    if (isReauthenticating)
        return false;
    const { updateState, state } = useUserSettingsStore();
    isReauthenticating = true;
    // Save new state that window for authentication is opened. Every Subscriber should handle it in own way.
    // Ideally registered in App.vue
    if (!state?.IsReloginInProgress) {
        updateState?.({ IsReloginInProgress: true });
    }
    const loginWindow = openLoginPopup();
    if (!loginWindow) {
        cleanup();
        return false;
    }
    try {
        await waitForWindowToClose(loginWindow);
        return true;
    }
    finally {
        cleanup();
    }
}
function openLoginPopup() {
    return window.open(closeWindowUrl, '_blank', 'width=600,height=700');
}
/**
 * Subscribe for an opened window. This way user won't lose the Login page and it will be popped up every 2 secs
 * @param loginWindow
 */
function waitForWindowToClose(loginWindow) {
    const focusInterval = window.setInterval(() => {
        if (loginWindow && !loginWindow.closed) {
            loginWindow.focus();
        }
    }, 2000);
    return new Promise((resolve) => {
        const checkInterval = window.setInterval(() => {
            if (loginWindow.closed) {
                window.clearInterval(checkInterval);
                window.clearInterval(focusInterval);
                resolve();
            }
        }, 500);
    });
}
/**
 * Clean all listeners and remove overlay
 */
function cleanup() {
    useUserSettingsStore()?.updateState?.({ IsReloginInProgress: false });
    isReauthenticating = false;
}
